import {Button, Chip, Divider, Step, StepLabel, Stepper} from '@mui/material'
import Box from '@mui/material/Box'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import {asConfirm, customConfirm} from 'utils/CustomAlert/Alert'
import {asInstallSteps} from 'pages/install/dataConfig/Steps'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
const AsStepHeader = (props: any) => {
  const {step, close, clear, setRenderStep, set, asSubmit} = props
  return (
    <div
      id={'as-install-modal-header'}
      className={'bg-white'}
      style={{position: 'sticky', top: 0, zIndex: 9999, flexShrink: 0}}
    >
      <div className={'w-100 d-flex justify-content-between align-items-center mb-1 mt-2 px-4'}>
        {step !== 0 ? (
          <Button
            variant={'text'}
            size={'large'}
            startIcon={
              <KeyboardDoubleArrowLeftIcon
                style={{
                  fontSize: '35px',
                  color: '#000',
                }}
              />
            }
            onClick={async () => {
              if (await customConfirm('이전 단계로 돌아가시겠습니까?', 'warning', '이전단계')) {
                const skipStep2 =
                  step === 3 &&
                  (asSubmit?.deviceType === 'digital' ||
                    (asSubmit?.resultIdx >= 5 && asSubmit?.resultIdx <= 10))
                if (skipStep2) {
                  setRenderStep((prev: any) => prev - 2)
                } else {
                  setRenderStep((prev: any) => prev - 1)
                }
                if (step === 1) {
                  set((prev: any) => ({
                    ...prev,
                    imei: null,
                    idxDate: null,
                    customerName: null,
                    customerNumber: null,
                    officeId: null,
                    resultIdxName: null,
                    resultIdx: null,
                    beforeImei: null,
                    createAt: null,
                    serialNumber: null,
                    filePath: null,
                    causeIdx: null,
                    causeName: null,
                    deviceType: null,
                    idx: null,
                    rssiStatus: null,
                    changeFlag: false,
                  }))
                } else if (step === 2) {
                  if (
                    asSubmit.resultIdx === 1 ||
                    asSubmit.resultIdx === 4 ||
                    (asSubmit?.resultIdx >= 5 && asSubmit?.resultIdx <= 10)
                  ) {
                    // efos or normalAs: device unchanged, reset only image edit fields
                    set((prev: any) => ({
                      ...prev,
                      contrast: 255,
                      digit: null,
                      brightness: 32,
                      changeFlag: false,
                      rotate: 0,
                      xstart: null,
                      ystart: null,
                      xend: null,
                      yend: null,
                      recognizedType: 'none',
                    }))
                  } else {
                    // device change (resultIdx 2, 3): reset new device + image edit fields
                    set((prev: any) => ({
                      ...prev,
                      contrast: 255,
                      digit: null,
                      brightness: 32,
                      filePath: null,
                      rssiStatus: null,
                      createAt: null,
                      deviceTypeName: null,
                      deviceType: null,
                      imei: null,
                      serialNumber: null,
                      idxDate: null,
                      changeFlag: false,
                      rotate: 0,
                      xstart: null,
                      ystart: null,
                      xend: null,
                      yend: null,
                      recognizedType: 'none',
                    }))
                  }
                } else if (step === 3) {
                  if (asSubmit?.resultIdx >= 5 && asSubmit?.resultIdx <= 10) {
                    // normalAs: always step 3 → step 1 (image edit skipped entirely)
                    set((prev: any) => ({
                      ...prev,
                      afterComment: '',
                    }))
                  } else {
                    if (asSubmit?.deviceType === 'analog') {
                      set((prev: any) => ({
                        ...prev,
                        xstart: null,
                        ystart: null,
                        xend: null,
                        yend: null,
                        afterComment: '',
                        digit: null,
                        recognizedType: 'none',
                        rotate: 0,
                        brightness: 32,
                        contrast: 255,
                        changeFlag: false,
                      }))
                    } else if (asSubmit?.deviceType === 'digital') {
                      set((prev: any) => ({
                        ...prev,
                        xstart: null,
                        ystart: null,
                        xend: null,
                        yend: null,
                        createAt: null,
                        deviceTypeName: null,
                        deviceType: null,
                        imei: null,
                        serialNumber: null,
                        rssiStatus: null,
                        changeFlag: false,
                        idxDate: null,
                        digit: null,
                        recognizedType: 'none',
                        rotate: 0,
                        brightness: 32,
                        contrast: 255,
                      }))
                    }
                  }
                }
              }
            }}
          >
            <span className={'text-dark fs-5'}>{asInstallSteps[step - 1]}</span>
          </Button>
        ) : (
          <div />
        )}
        <div className={'text-center'} style={{minWidth: 64}}>
          <CancelPresentationIcon
            sx={{fontSize: '35px'}}
            color={'error'}
            onClick={async () => {
              if (await asConfirm('A/S를 종료하시겠습니까?', 'warning', '종료')) {
                close()
                clear()
              }
            }}
          />
        </div>
      </div>
      <Box sx={{width: '100%'}}>
        <Stepper activeStep={step} alternativeLabel>
          {asInstallSteps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div
          id={'matching-info'}
          className={'d-flex gap-2 align-items-center justify-content-center my-1'}
        >
          {asSubmit?.customerName && (
            <Chip
              label={`${asSubmit?.customerName}님  ${
                asSubmit?.resultIdxName === null ? 'A/S ' : asSubmit?.resultIdxName
              } 진행 중`}
              variant={'outlined'}
              color={'secondary'}
              className={'fs-4 '}
            />
          )}
        </div>
        <Divider className={'border border-gray-600 mb-2'} />
      </Box>
    </div>
  )
}
export default AsStepHeader
